import script from "./ChartOTR.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartOTR.vue?vue&type=script&setup=true&lang=js"

import "./ChartOTR.vue?vue&type=style&index=0&id=dd122f54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd122f54"]])

export default __exports__